"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SousStatus = exports.ServiceRequestErrorType = exports.ServiceRequestType = void 0;
var ServiceRequestType;
(function (ServiceRequestType) {
    ServiceRequestType["REQUEST_CREDIT"] = "REQUEST_CREDIT";
    ServiceRequestType["PICKUP_REQUEST"] = "PICKUP_REQUEST";
    ServiceRequestType["RECOVERY_REQUEST"] = "RECOVERY_REQUEST";
    ServiceRequestType["SUPPORT_REQUEST"] = "SUPPORT_REQUEST";
})(ServiceRequestType = exports.ServiceRequestType || (exports.ServiceRequestType = {}));
var ServiceRequestErrorType;
(function (ServiceRequestErrorType) {
    ServiceRequestErrorType["MULESOFT_ERROR"] = "MULESOFT_ERROR";
    ServiceRequestErrorType["S3_ERROR"] = "S3_ERROR";
    ServiceRequestErrorType["SOUS_ERROR"] = "SOUS_ERROR";
    ServiceRequestErrorType["OTHER_ERROR"] = "OTHER_ERROR";
})(ServiceRequestErrorType = exports.ServiceRequestErrorType || (exports.ServiceRequestErrorType = {}));
var SousStatus;
(function (SousStatus) {
    SousStatus["NEW"] = "NEW";
    SousStatus["CREATED"] = "CREATED";
    SousStatus["FAILED"] = "FAILED";
    SousStatus["IN_PROGRESS"] = "IN_PROGRESS";
    SousStatus["APPROVED"] = "APPROVED";
    SousStatus["PENDING_CDMR_DECISION"] = "PENDING_CDMR_DECISION";
    SousStatus["CLOSED"] = "CLOSED";
})(SousStatus = exports.SousStatus || (exports.SousStatus = {}));
